// Não utilizar esse enum, utilizar o Language.enum
enum LanguageEnum {
  PTBR = 'ptbr',
  EN = 'en',
  ES = 'es',
}

export { LanguageEnum };
